import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, LogOut } from 'lucide-react';

// Navy header shared by the signed-in pages (account + leads dashboard).
export const PageHeader = ({ widthClass, logoutTestId, onLogout }) => (
  <header className="bg-[#143160] text-white">
    <div className={`${widthClass} mx-auto px-5 py-4 flex items-center justify-between`}>
      <Link to="/" className="flex items-center space-x-2 text-gold-300 hover:text-gold-200"><ArrowLeft className="w-4 h-4" /><span>Back to site</span></Link>
      <button type="button" data-testid={logoutTestId} onClick={onLogout} className="flex items-center space-x-2 text-sm font-semibold hover:text-gold-300"><LogOut className="w-4 h-4" /><span>Sign out</span></button>
    </div>
  </header>
);

export const PageLoading = ({ label }) => (
  <div className="min-h-screen flex items-center justify-center text-[#143160]">{label}</div>
);
